import React, { useState } from "react";
import { isEmpty } from "lodash";
import { apiDelete } from "utils/apiFetch";
import apiPath from "../../../utils/pathObj";
import dayjs from "dayjs";
import { AiFillEye, AiFillEdit, AiFillDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import helpers from "utils/helpers";
import EditOnboarding from "./EditOnboarding";
import { useNavigate } from "react-router-dom";

const OnboardingList = ({ forms, handleFormsView, page,  getForms, sort, setSort }) => {
  const { t } = useTranslation();

     const [onboardingEdit, setOnboardingEdit] = useState(false);
     const [selectedFormId, setSelectedFormId] = useState(null);
     const navigate = useNavigate();
  
    //  const handleEditOnboarding = (formId) => {
    //   setSelectedFormId(formId);
    //   setOnboardingEdit(true);
    // };
    
    const handleEditOnboarding = (formId) => {
      navigate("/forms_manager/onboarding-edit", { state: { id: formId } });
    };
    
    
    const closeModal = () => {
      setOnboardingEdit(false);
    };
    
    const handleDelete = async (item) => {
      try {
        await apiDelete(`${apiPath.deleteForm}/${item._id}`);
        getForms(); // Refresh the list after deletion
      } catch (error) {
        console.log("Delete error:", error);
      }
    };

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                Sr no.
              </th>
              <th scope="col" className="py-3 px-6">
                {t("TITLE")}
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-start">
                  <span>{t("CREATED_DATE")}</span>
                  <span>
                    {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {forms &&
              forms?.map((item, i) => (
                <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                  {Math.max(1, (page - 1) * 10 + i + 1)}
                  </th>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.formName} </td>
                  <td className="py-4 px-6 border-r text-gray-900">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")} </td>

                  <td className="py-4 px-6 border-l text-gray-900">
                    <div className="">
                      <ul className="flex justify-center">
                        <li onClick={() => handleFormsView(item?._id)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                          <a title={t("O_VIEW_USER")}>
                            {" "}
                            <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                          </a>
                        </li>
                        <li 
                          onClick={() => handleEditOnboarding(item?._id)} 
                          className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                          <a title="Edit" className="hover:text-blue-700 transition duration-150 ease-in-out" data-bs-toggle="tooltip">
                          {" "}
                          <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                          </a>
                         </li>   
                         <li onClick={() => {
                            helpers.alertFunction(
                              `Are you sure want to delete '${item.formName}'?`,
                              item,
                              handleDelete,
                              true
                            );
                          }} 
                          className="px-2 py-2 hover:bg-white hover:text-slate-800">
                          <a title="Delete">
                          <AiFillDelete className="cursor-pointer w-5 h-5 text-slate-600" />
                              </a>
                          </li>                    
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
{             helpers.ternaryCondition(
                      onboardingEdit,
                      <EditOnboarding 
                        handleEditOnboarding={handleEditOnboarding}
                        onboardingEdit={onboardingEdit}
                        getForms={getForms}
                        closeModal={closeModal}
                        formId={selectedFormId}
                        forms={forms}
                      />,
                      null
                    )}
            {isEmpty(forms) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={4}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OnboardingList;
